define('apps/course-intro/app',[
    'apps/course-intro/views/main-layout',
    'components/course/models/course'
], function (View, Course) {
    "use strict";

    return Mn.Application.extend({
        "initialize": function () {
            this.model = new Course();
            this.view = new View({
                "model": this.model
            });
        },

        "onStart": function (courseData) {
            this.model.set(courseData);
            this.view.render();
        }
    });
});

